const COOKIE_NAME = 'ha-global-banner';

function getCookieName(name, id = '') {
    return `${name && id ? `${name}-` : name}${id}`;
}

/**
 * Creates a cookie string with the specified name, value and expiration.
 *
 * @param {String} name - Name of the cookie property
 * @param {String} value - The value for the cookie.
 * @param {Number} days - Number of days before expired
 */
function createCookie(name, value, days = 1) {
    const expireTime = new Date();
    value = encodeURIComponent(value);
    expireTime.setTime(expireTime.getTime() + days * 24 * 60 * 60 * 1000);
    const cookie = [
        name,
        '=',
        value,
        ';expires=',
        expireTime.toUTCString(),
        '; path=/;',
    ].join('');

    return cookie;
}

/**
 * Writes a cookie value if the user has accepted functional cookies.
 *
 * @param {String} name - Name of the cookie property
 * @param {String} value - The value for the cookie.
 * @param {String} id - The message identifier
 * @param {Number} days - Number of days before expired
 */
function writeCookie(name, value, id, days) {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
    }

    window.cookieconsent = window.cookieconsent || [];
    window.cookieconsent.push((cookieAccess) => {
        const consents = cookieAccess && cookieAccess.getConsents();
        // Write the cookie only if functional cookies are allowed by user.
        if (consents && consents.functional === true) {
            document.cookie = createCookie(
                getCookieName(name, id),
                value,
                days
            );
        }
    });
}

/**
 * Returns the value of the specified cookie.
 *
 * @param {String} name - Name of cookie to retrieve
 * @param {String} id - The message identifier
 */
function readCookie(name, id) {
    const cookieSource =
        typeof document !== 'undefined' && document.cookie
            ? document.cookie
            : '';
    const regexValue = '=([^;]+)';
    const match = cookieSource.match(
        new RegExp(getCookieName(name, id) + regexValue)
    );
    let result = '';

    if (match && match.length > 0) {
        result = decodeURIComponent(match[1]);
    }

    return result;
}

/**
 * Returns a boolean flag for whether the user has dismissed a banner.
 *
 * @param {String} cookieString - A cookie string
 * @param {String} bannerId - The banner identifier
 */
function hasUserDismissed(cookieString, bannerId) {
    if (!cookieString || !bannerId) {
        return false;
    }
    const regexValue = '=([^;]+)';
    const match = cookieString.match(
        new RegExp(getCookieName(COOKIE_NAME, bannerId) + regexValue)
    );

    if (match && match.length > 0) {
        return decodeURIComponent(match[1]) === 'true';
    }

    return false;
}

export {createCookie, readCookie, writeCookie, hasUserDismissed, COOKIE_NAME};
